/* Aurora add-to-cart feedback and nav bar; CSS in aurora-accents.css. Opt out: data-aur-no-loader */
(() => {
'use strict';

const doc = document;
const html = doc.documentElement;
const S = (window.themeVariables && window.themeVariables.strings) || {};
const ADDED_MS = 1200;
const ATC_SAFETY_MS = 20000; // online fetch failure
const NAV_SAFETY_MS = 15000; // no unload, no abort event
const NAV_DONE_MS = 1000;
const PRESS_MAX_W = 0.6; // of viewport width: banners get no press
const PROXIES = { aurAtc: 'aurSticky2' }; // sticky forwards atc.click()

const closestEl = (n, sel) => {
  const el = n && n.nodeType === 1 ? n : n && n.parentElement;
  return el ? el.closest(sel) : null;
};
const optedOut = (el) => !!el.closest('[data-aur-no-loader]');

/* Add to cart */

const records = new Set(); // { form, buttons, phase: pending|loading|added, timer }
const isCartForm = (f) => !!f && f.tagName === 'FORM' && (f.getAttribute('action') || '').includes('/cart/add');
const submits = (form) => Array.from(form.elements).filter((el) => el.type === 'submit');
const busy = (b) => b.getAttribute('aria-busy') === 'true';
const recordFor = (form) => {
  for (const r of records) if (r.form === form) return r;
  return null;
};

const release = (rec, restoreBusy) => {
  clearTimeout(rec.timer);
  records.delete(rec);
  rec.buttons.forEach((b) => {
    b.removeAttribute('data-aur-atc');
    b.removeAttribute('data-aur-added');
    if (restoreBusy && busy(b)) b.removeAttribute('aria-busy'); // rejected fetch
  });
};

const mark = (form, phase) => {
  const own = submits(form); // theme.js marks these aria-busy
  const proxies = own.map((b) => PROXIES[b.id] && doc.getElementById(PROXIES[b.id])).filter(Boolean);
  const rec = { form, buttons: new Set(own.concat(proxies)), phase, timer: 0 };
  rec.buttons.forEach((b) => {
    b.setAttribute('data-aur-atc', 'loading');
    if (S.auroraAdded) b.setAttribute('data-aur-added', S.auroraAdded);
  });
  rec.timer = setTimeout(() => release(rec, true), ATC_SAFETY_MS);
  records.add(rec);
};

// <buy-buttons form=id> (pre-order, quick buy) announces its own form.
const announce = (form, holderId, msg) => {
  const id = form.getAttribute('id'); // form.id is the variant input
  const own = !!id && Array.from(doc.getElementsByTagName('buy-buttons')).some((el) => el.getAttribute('form') === id);
  const holder = doc.getElementById(holderId);
  if (own || !holder || !msg || typeof msg !== 'string') return;
  holder.textContent = '';
  setTimeout(() => { holder.textContent = msg; }, 100);
};

// Discovery CTA: cancels the click, pre-adds the pouch, re-clicks itself.
let deferred = null;

doc.addEventListener('click', (e) => {
  deferred = null;
  const btn = closestEl(e.target, 'button, input[type="submit"]');
  if (!btn) return;
  if (btn.hasAttribute('data-aur-atc')) {
    // Loading or added: block user clicks. Forwarded clicks pass; duplicates die at submit.
    if (e.isTrusted) { e.preventDefault(); e.stopImmediatePropagation(); }
    return;
  }
  if (btn.id === 'aurdCta' && isCartForm(btn.form)) {
    const toast = doc.getElementById('aurdToast');
    deferred = { btn, toastNode: toast && toast.firstChild };
  }
}, true);

window.addEventListener('click', (e) => {
  const d = deferred;
  deferred = null;
  if (!d || !e.defaultPrevented || recordFor(d.btn.form)) return;
  const act = d.btn.closest('.aurd__act');
  const toast = doc.getElementById('aurdToast');
  // A "choose more" toast replaced the text: nothing is added.
  if (act && act.classList.contains('done') && !(toast && toast.firstChild !== d.toastNode)) mark(d.btn.form, 'pending');
});

doc.addEventListener('submit', (e) => {
  const form = e.target;
  if (!isCartForm(form)) return;
  const rec = recordFor(form);
  if (rec && rec.phase === 'loading') { // duplicate mid-add
    e.preventDefault();
    e.stopImmediatePropagation();
    return;
  }
  const submitter = e.submitter || submits(form)[0];
  if (submitter && busy(submitter)) return; // theme.js ignores it too
  if (rec) release(rec, false);
  mark(form, 'loading');
}, true);

// Invalid form (theme.js set no aria-busy): drop the state.
window.addEventListener('submit', (e) => {
  const rec = isCartForm(e.target) ? recordFor(e.target) : null;
  if (rec && rec.phase === 'loading' && !submits(rec.form).some(busy)) release(rec, false);
});

doc.addEventListener('variant:add', (e) => {
  const rec = recordFor(e.target);
  if (!rec) return;
  clearTimeout(rec.timer);
  rec.phase = 'added';
  rec.buttons.forEach((b) => b.setAttribute('data-aur-atc', 'added'));
  announce(rec.form, 'status-announcement', S.auroraAddedToBag);
  rec.timer = setTimeout(() => release(rec, false), ADDED_MS);
});

doc.addEventListener('cart:error', (e) => {
  const rec = recordFor(e.target);
  if (!rec) return;
  release(rec, false); // existing error UI takes over
  announce(rec.form, 'error-announcement', e.detail && e.detail.error);
});

// theme.js onSubmit has no catch, and other scripts reject too: unlock only offline or on bad JSON.
window.addEventListener('unhandledrejection', (e) => {
  const r = e.reason;
  const offline = r instanceof TypeError && navigator.onLine === false;
  records.forEach((rec) => {
    if (offline && rec.phase !== 'added') release(rec, true);
    else if (r instanceof SyntaxError && rec.phase === 'loading' && !submits(rec.form).some(busy)) release(rec, false);
  });
});

// Drawer re-render replaces cross-sell forms.
doc.addEventListener('cart:change', () => {
  records.forEach((r) => { if (!r.form.isConnected) release(r, false); });
});

/* Navigation loader */

let navTimer = 0;
const navHide = () => {
  clearTimeout(navTimer);
  html.removeAttribute('data-aur-nav');
  doc.querySelectorAll('[data-aur-pressed]').forEach((el) => el.removeAttribute('data-aur-pressed'));
};
const navShow = (pressed, event) => {
  clearTimeout(navTimer);
  html.setAttribute('data-aur-nav', 'start');
  // An attribute, never an aur* class: aurora-ar.css restyles [class^="aur"].
  if (pressed && pressed.offsetWidth < window.innerWidth * PRESS_MAX_W) pressed.setAttribute('data-aur-pressed', '');
  navTimer = setTimeout(() => {
    html.setAttribute('data-aur-nav', 'done');
    navTimer = setTimeout(navHide, NAV_DONE_MS);
  }, NAV_SAFETY_MS);
  if (event) setTimeout(() => { if (event.defaultPrevented) navHide(); }, 0); // a later listener cancelled
};

const pageUrl = (raw) => {
  const v = (raw || '').trim();
  if (!v || v.charAt(0) === '#') return null;
  try {
    const u = new URL(v, location.href);
    return /^https?:$/.test(u.protocol) && u.origin === location.origin ? u : null;
  } catch (err) { return null; }
};
const samePageHash = (u) => !!u.hash && u.pathname === location.pathname && u.search === location.search;
const selfTarget = (t) => !t || t.trim().toLowerCase() === '_self';

const initNav = () => {
  if (window.Shopify && window.Shopify.designMode) return; // theme editor

  const bar = doc.createElement('div');
  bar.className = 'aur-nav';
  bar.setAttribute('aria-hidden', 'true');
  doc.body.appendChild(bar);

  // Stop/Esc aborts a navigation; a replacing one fires navigate in the same task.
  const api = window.navigation;
  if (api) {
    let seq = 0;
    api.addEventListener('navigate', () => { seq += 1; });
    api.addEventListener('navigateerror', () => {
      const s = seq;
      setTimeout(() => { if (s === seq) navHide(); }, 0);
    });
  }

  // Menu summary: theme.js cancels, then navigates if open. Snapshot first.
  let follow = null;
  window.addEventListener('click', (e) => {
    const s = closestEl(e.target, 'summary[data-follow-link]');
    follow = s && s.parentElement && s.parentElement.open ? s : null;
  }, true);

  // Bubble phase: cancelled toggles never show the bar.
  window.addEventListener('click', (e) => {
    const summary = follow;
    follow = null;
    if (e.button !== 0) return;
    if (e.defaultPrevented) {
      const u = summary && summary.contains(e.target) ? pageUrl(summary.getAttribute('data-follow-link')) : null;
      if (u && !samePageHash(u) && !optedOut(summary)) navShow(summary, null);
      return;
    }
    // Locale go: its handler disables the button, then form.submit().
    const go = closestEl(e.target, 'button[data-aurls-go]');
    if (go) {
      if (go.disabled) navShow(null, null);
      return;
    }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const path = e.composedPath ? e.composedPath() : [];
    const link = closestEl(e.target, 'a[href], area[href]') ||
      path.find((n) => (n.localName === 'a' || n.localName === 'area') && n.hasAttribute('href'));
    if (!link || link.hasAttribute('download') || optedOut(link) || !selfTarget(link.getAttribute('target'))) return;
    const u = pageUrl(link.getAttribute('href'));
    if (u && !samePageHash(u)) navShow(link, e);
  });

  // Native form navigations; never /cart/add.
  const NAV_FORM = /\/(?:localization|search|cart|contact|account)(?:\/|$)/;
  window.addEventListener('submit', (e) => {
    const form = e.target;
    const sub = e.submitter;
    if (e.defaultPrevented || !form || form.tagName !== 'FORM' || optedOut(form)) return;
    if (!selfTarget((sub && sub.getAttribute('formtarget')) || form.getAttribute('target'))) return;
    const u = pageUrl((sub && sub.getAttribute('formaction')) || form.getAttribute('action'));
    if (u && NAV_FORM.test(u.pathname) && !u.pathname.includes('/cart/add')) navShow(null, e);
  });

  // Sort select sets location.href.
  doc.addEventListener('change', (e) => {
    if (e.target && e.target.id === 'aurcolSort') navShow(null, null);
  });
};

// bfcache restores the DOM as left: never come back stuck.
const resetAll = () => {
  navHide();
  records.forEach((r) => release(r, true));
};
window.addEventListener('pagehide', resetAll);
window.addEventListener('pageshow', (e) => { if (e.persisted) resetAll(); });

if (doc.body) initNav();
else doc.addEventListener('DOMContentLoaded', initNav);
})();
